






















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Tag from '@/components/common/ncpLayerPopup/Tag.vue';
import DatePicker from 'tui-date-picker';
import {changeDateFormat} from '@/utils/dateUtils';
import TimePicker from '@/components/board/common/PageFormSelect.vue';

@Component({
  components: {
    Tag,
    TimePicker
  }
})
export default class PageDateRangePicker extends Vue {
  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  @Prop({required: false, default: 'span', type: String}) private tag?: string;
  @Prop({required: false, default: false, type: Boolean}) private timePicker?: false;
  @Prop({
    required: false,
    default: function () {
      return {start: false, end: false};
    },
    type: Object
  })
  private disableObject?: {start: boolean; end: boolean};
  private get isShow() {
    return this.timePicker ? 'display: inline-block;' : 'display: none;';
  }

  @Prop({required: false, type: Object})
  private readonly dateObject!: {startYmd: string; endYmd: string};
  private dateObjectClone = {...this.dateObject};

  @Prop({
    required: false,
    type: Object,
    default: function () {
      return {startTime: '00:00', endTime: '23:59'};
    }
  })
  private readonly timeObject?: {startTime: string; endTime: string};
  private timeObjClone: {startTime: string; endTime: string};
  @Watch('timeObject', {immediate: true, deep: true})
  onTimeObjectChange({startTime, endTime}: any) {
    this.$nextTick(() => {
      this.timeObjClone = {startTime, endTime};
    });
  }

  private dateObjectFlagStart = false;
  private dateObjectFlagEnd = false;

  @Watch('dateObject', {immediate: true, deep: true})
  onDateObjectChange({startYmd, endYmd}: any) {
    this.$nextTick(() => {
      const startDateStamp = changeDateFormat(this.startPicker.getDate(), 'Y-MM-DD');
      this.dateObjectFlagStart = startDateStamp !== startYmd
      const oldDateStamp = changeDateFormat(this.endPicker.getDate(), 'Y-MM-DD');
      this.dateObjectFlagEnd = oldDateStamp !== endYmd

      setTimeout(() => {
        this.startPicker.setDate(this.dateTimeFormat(startYmd, 'start'));
        this.endPicker.setDate(this.dateTimeFormat(endYmd, 'end'));
        this.dateObjectClone = {startYmd, endYmd};
        this.setStartRanges();
        this.setEndRanges();
      }, 10);
    });
  }

  @Prop({required: false, type: String}) initRangeStartYmd?: string;

  private readonly alertMsg = '시작일자는 종료일자보다 클 수 없습니다.';

  private setStartRanges() {
    const endYmd = changeDateFormat(this.instance.getEndDate(), 'Y-MM-DD');

    if (!this.startPicker.isDisabled()) {
      this.startPicker.enable();
      if (this.initRangeStartYmd) {
        this.startPicker.setRanges([[this.dateTimeFormat(this.initRangeStartYmd), this.dateTimeFormat(endYmd, 'end')]]);
      } else {
        this.startPicker.setRanges([[this.dateTimeFormat('1970-01-01'), this.dateTimeFormat(endYmd, 'end')]]);
      }
    }
  }

  private setEndRanges() {
    const startYmd = changeDateFormat(this.instance.getStartDate(), 'Y-MM-DD');

    if (!this.endPicker.isDisabled()) {
      this.endPicker.enable();
      this.endPicker.setRanges([[this.dateTimeFormat(startYmd), this.dateTimeFormat('2999-12-31', 'end')]]);
    }
  }

  private dateChange(whoseDate: string) {
    const startYmd = changeDateFormat(this.instance.getStartDate(), 'Y-MM-DD');
    const endYmd = changeDateFormat(this.instance.getEndDate(), 'Y-MM-DD');
    this.dateObjectClone = {startYmd, endYmd};
    this.$emit('change', {startYmd, endYmd, isBtnSet: this.dateObjectFlagStart || this.dateObjectFlagEnd});
    if (this.dateObjectFlagStart && whoseDate === 'start') this.dateObjectFlagStart = false;
    if (this.dateObjectFlagEnd && whoseDate === 'end') this.dateObjectFlagEnd = false;
    this.$nextTick(() => {
      this.setStartRanges();
      this.setEndRanges();
    });

    if (this.disableObject?.end && this.disableObject?.start) {
      this.endPicker.disable();
      this.startPicker.disable();
      this.startPicker._datepickerInput._input.value = '';
      this.endPicker._datepickerInput._input.value = '';
    } else {
      this.endPicker.enable();
      this.startPicker.enable();
      this.startPicker._datepickerInput._input.value = startYmd;
      this.endPicker._datepickerInput._input.value = endYmd;
    }
    
  }

  private checkTime() {
    const startYmd = changeDateFormat(this.instance.getStartDate(), 'Y-MM-DD');
    const endYmd = changeDateFormat(this.instance.getEndDate(), 'Y-MM-DD');
    if (this.instance.getStartDate().getTime() === this.instance.getEndDate().getTime()) {
      if (this.dateTimeFormat(startYmd).getTime() > this.dateTimeFormat(endYmd, 'end').getTime()) {
        return false;
      }
    }
    return true;
  }

  private timeChange(startOrEnd: string) {
    if (!this.checkTime()) {
      alert(this.alertMsg);
      if (startOrEnd === 'start') {
        Object.assign(this.timeObjClone, this.timeObject ? {startTime: this.timeObject.startTime} : {startTime: '00:00'});
      } else {
        Object.assign(this.timeObjClone, this.timeObject ? {endTime: this.timeObject.endTime} : {endTime: '23:59'});
      }
    } else {
      this.$emit('timeChange', {...this.timeObjClone});
    }
  }

  private startTimeData = this.generateTimeData('00');
  private endTimeData = this.generateTimeData('59');

  private instance: any;
  private startPicker: any;
  private endPicker: any;

  private generateTimeData(suffix: string) {
    return Array.from(Array(24).keys()).map((time) => {
      const value = `${time}:${suffix}`.padStart(5, '0');
      const label = value;
      return {label, value};
    });
  }

  private showMask(isShow: boolean): void {
    const pop = document.getElementById('pop');
    if (!pop) return;
    if (isShow) {
      pop.style.display = 'block';
    } else {
      pop.style.display = 'none';
    }
  }

  private dateTimeFormat(value: string, type: string = 'start'): Date {
    if (type === 'start') {
      return new Date(`${value} ${this.timeObjClone.startTime}`);
    } else {
      return new Date(`${value} ${this.timeObjClone.endTime}`);
    }
  }

  private created() {
    this.timeObjClone = this.timeObject ? {...this.timeObject} : {startTime: '00:00', endTime: '23:59'};
  }

  private mounted() {
    this.instance = DatePicker.createRangePicker({
      startpicker: {
        input: '#startpicker-input',
        container: '#startpicker-container'
      },
      endpicker: {
        input: '#endpicker-input',
        container: '#endpicker-container'
      },
      language: 'ko',
      format: 'yyyy-MM-dd'
    });

    this.startPicker = this.instance.getStartpicker();
    this.endPicker = this.instance.getEndpicker();

    this.startPicker.on('change', (): void => {
      const dateStamp = changeDateFormat(this.startPicker.getDate(), 'Y-MM-DD');
      if (this.dateObjectClone.startYmd === dateStamp) {
        this.dateObjectFlagStart = false;
        return;
      }
      this.dateChange('start');
    });

    this.endPicker.on('change', (): void => {
      const dateStamp = changeDateFormat(this.endPicker.getDate(), 'Y-MM-DD');
      if (this.dateObjectClone.endYmd === dateStamp) {
        this.dateObjectFlagEnd = false;
        return;
      }
      this.dateChange('end');
    });

    this.startPicker.on('open', (): void => {
      this.showMask(true);
    });
    this.endPicker.on('open', (): void => {
      this.showMask(true);
    });
    this.startPicker.on('close', (): void => {
      this.showMask(false);
    });
    this.endPicker.on('close', (): void => {
      this.showMask(false);
    });

    this.endPicker.setDate(this.dateTimeFormat(this.dateObject.endYmd, 'end'));

    jQuery(() => {
      $('body').on('click', '.tui-calendar-header-info', (e: any) => {
        const $this = $(e.currentTarget);
        if ($this.parents('#startpicker-container').length) {
          const wantToSetDate = this.dateTimeFormat(this.today);
          const endDate = this.dateTimeFormat(changeDateFormat(this.endPicker.getDate(), 'Y-MM-DD'), 'end');
          if (wantToSetDate.getTime() > endDate.getTime()) {
            alert(this.alertMsg);
          } else {
            this.startPicker.setDate(wantToSetDate);
            this.startPicker.close();
          }
        }

        if ($this.parents('#endpicker-container').length) {
          const wantToSetDate = this.dateTimeFormat(this.today, 'end');
          const startDate = this.dateTimeFormat(changeDateFormat(this.startPicker.getDate(), 'Y-MM-DD'));

          if (startDate.getTime() > wantToSetDate.getTime()) {
            alert(this.alertMsg);
          } else {
            this.endPicker.setDate(wantToSetDate);
            this.endPicker.close();
          }
        }
      });
    });
  }
}
